import React from 'react';
import { createRoot } from 'react-dom/client';
import "antd/dist/antd.min.css";
import '@fontsource-variable/raleway';
import '@fontsource-variable/raleway/wght-italic';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);